module.exports = __webpack_public_path__ + "static/media/icon_4.0dda2ba3.svg";